// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1tVbY","head":"ProcedureTableInfo_head__377G9"};